import FollowUps from "../settings/follow-ups";

export default function AiFollowUps () {
  return (
    <div className="flex flex-column gap-4 w-100 h-100 pb-4 px-4 overflow-y-scroll">
      <FollowUps />
    </div>
  )
}
